[
    { "displayedName": "FTTH", "name": "ftth", "type": "Fibre", "default": true },
    { "displayedName": "FTTE", "name": "ftte", "type": "Fibre", "default": true },
    { "displayedName": "FTTO", "name": "ftto", "type": "Fibre", "default": true },
    { "displayedName": "FTTO Burst", "name": "ftto_burst", "type": "Fibre", "default": true },
    { "displayedName": "ADSL", "name": "adsl", "type": "Cuivre", "default": false },
    { "displayedName": "VDSL", "name": "vdsl", "type": "Cuivre", "default": false },
    { "displayedName": "SDSL", "name": "sdsl", "type": "Cuivre", "default": false }
]